import styled from "styled-components";
import { theme } from "../theme";

export const Strong = styled("span")(({ fontWeight }) => {
  // Default values for  weight
  const defaultFontWeight = 500;

  // Determine fontWeight for different breakpoints
  const fontWeightValue = fontWeight || defaultFontWeight;
  const smFontWeight =
    typeof fontWeightValue === "object"
      ? fontWeightValue.sm ||
        fontWeightValue.md ||
        fontWeightValue.lg ||
        fontWeightValue
      : fontWeightValue;
  const mdFontWeight =
    typeof fontWeightValue === "object"
      ? fontWeightValue.md || fontWeightValue.lg || fontWeightValue
      : fontWeightValue;
  const lgFontWeight =
    typeof fontWeightValue === "object"
      ? fontWeightValue.lg || fontWeightValue
      : fontWeightValue;

  return {
    fontWeight: lgFontWeight,
    // Responsive styles
    "@media (max-width: 600px)": {
      fontWeight: smFontWeight,
    },
    "@media (min-width: 601px) and (max-width: 1200px)": {
      fontWeight: mdFontWeight,
    },
  };
});

export const Box = styled(({ component: Element = "div", ...props }) => (
  <Element {...props} />
))((props) => {
  
  const { display, p, px, py, pt, pr, pl, pb, m, mx, my, mt, mr, ml, mb,color,colorVariant, bgColor,wrap ,sx = {},width,height} =
    props;
  const prem = p && (p !== "auto" ? `${p / 16}rem` : "auto");
  const mrem = m && (m !== "auto" ? `${m / 16}rem` : "auto");
  // Determine the color value
  const colorValue = color
    ? theme.colors[color]
      ? colorVariant
        ? theme.colors[color][colorVariant]
        : theme.colors[color].main
      : color
    : theme.colors.dark.main;
  const bgColorValue = bgColor
    ? theme.colors[bgColor]
      ? colorVariant
        ? theme.colors[bgColor][colorVariant]
        : theme.colors[bgColor].main
      : color
    : "transparent";
  return {
    display: display || "block",
    backgroundColor: bgColorValue,
    color: colorValue,
    padding: prem,
    paddingBlock: py && `${py / 16}rem`,
    paddingBlockStart: pt && `${pt / 16}rem`,
    paddingBlockEnd: pb && `${pb / 16}rem`,
    paddingInline: px && `${px / 16}rem`,
    paddingInlineStart: pl && `${pl / 16}rem`,
    paddingInlineEnd: pr && `${pr / 16}rem`,
    margin: mrem,
    marginBlock: my && (my !== "auto" ? `${my / 16}rem` : "auto"),
    marginBlockStart: mt && (mt !== "auto" ? `${mt / 16}rem` : "auto"),
    marginBlockEnd: mb && (mb !== "auto" ? `${mb / 16}rem` : "auto"),
    marginInline: mx && (mx !== "auto" ? `${mx / 16}rem` : "auto"),
    marginInlineStart: ml && (ml !== "auto" ? `${ml / 16}rem` : "auto"),
    marginInlineEnd: mr && (mr !== "auto" ? `${mr / 16}rem` : "auto"),
    // backgroundColor: bgColor || "transparent", 
    whiteSpace:wrap|| "none",
    height:height,
    width:width,
    ...sx,

  };
});

export const Flex = styled(Box)((props) => {
  const { alignItem, justifyContent, wrap, gap, direction, width, height } = props;

  // Create gap sizes for responsiveness
  const gapSizes = {
    xs: gap?.xs || gap || 0, // Default to 0 if gap is not provided
    sm: gap?.sm || gap?.xs || gap || 0,
    md: gap?.md || gap?.sm || gap?.xs || gap || 0,
    lg: gap?.lg || gap?.md || gap?.sm || gap?.xs || gap || 0,
    xl: gap?.xl || gap?.lg || gap?.md || gap?.sm || gap?.xs || gap || 0,
    xxl:
      gap?.xxl ||
      gap?.xl ||
      gap?.lg ||
      gap?.md ||
      gap?.sm ||
      gap?.xs ||
      gap ||
      0,
  };

  return {
    display: "flex",
    alignItems: alignItem,
    justifyContent: justifyContent,
    flexWrap: wrap,
    flexDirection: direction,
    width:width,
    height:height,
    gap: `${gapSizes.xxl / 16}rem`,

    "@media (max-width: 500px)": {
      gap: `${gapSizes.xs / 16}rem`,
    },
    "@media (min-width: 501px) and (max-width: 700px)": {
      gap: `${gapSizes.sm / 16}rem`,
    },
    "@media (min-width: 701px) and (max-width: 1000px)": {
      gap: `${gapSizes.md / 16}rem`,
    },
    "@media (min-width: 1001px) and (max-width: 1200px)": {
      gap: `${gapSizes.lg / 16}rem`,
    },
    "@media (min-width: 1201px) and (max-width: 1500px)": {
      gap: `${gapSizes.xl / 16}rem`,
    },
  };
});

export const SectionLayout = styled(Box).attrs({ as: "section" })((props) => {
  const { bg } = props;
  return {
    display: "block",
    position: "relative",
    backgroundColor: bg,
    overflow: "hidden",
  };
});

export const SectionContainer = styled(Box)(() => ({
  maxWidth: "90rem",
  paddingInline: "3.125rem",
  marginInline: "auto",
}));

export const Divider = styled(Box)((props) => {
  const { gap, vertical } = props;
  const gapSizes = gap || 0;
  return {
    width: vertical ? "0.0625rem" : "100%",
    height: vertical ? "100%" : "0.0625rem",
    margin: vertical ? `0 ${gapSizes / 16}rem` : `${gapSizes / 16}rem 0`,
    backgroundColor: theme.colors.default.main,
  };
});
export const Gap = styled(Box)((props) => {
  const { height } = props;
  const gapSizes = {
    xs: height?.xs || height || 0, // Default to 0 if height is not provided
    sm: height?.sm || height?.xs || height || 0,
    md: height?.md || height?.sm || height?.xs || height || 0,
    lg: height?.lg || height?.md || height?.sm || height?.xs || height || 0,
    xl:
      height?.xl ||
      height?.lg ||
      height?.md ||
      height?.sm ||
      height?.xs ||
      height ||
      0,
    xxl:
      height?.xxl ||
      height?.xl ||
      height?.lg ||
      height?.md ||
      height?.sm ||
      height?.xs ||
      height ||
      0,
  };
  return {
    width: "100%",
    height: `${gapSizes.xxl / 16}rem`,
    "@media (max-width: 500px)": {
      height: `${gapSizes.xs / 16}rem`,
    },
    "@media (min-width: 501px) and (max-width: 700px)": {
      height: `${gapSizes.sm / 16}rem`,
    },
    "@media (min-width: 701px) and (max-width: 1000px)": {
      height: `${gapSizes.md / 16}rem`,
    },
    "@media (min-width: 1001px) and (max-width: 1200px)": {
      height: `${gapSizes.lg / 16}rem`,
    },
    "@media (min-width: 1201px) and (max-width: 1500px)": {
      height: `${gapSizes.xl / 16}rem`,
    },
  };
});
